'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../../node_modules/classnames/index.js');

var index = require('../../../../node_modules/prop-types/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var MobileNavDrawer = function MobileNavDrawer(_ref) {
  var open = _ref.open,
      children = _ref.children,
      className = _ref.className;
  var MobileNavdrawerClasses = index$1['default'](className, 'lanl-mobile-nav-drawer', open ? 'lanl-mobile-nav-drawer--active' : '');
  React.useEffect(function () {
    var mobileNav = document.querySelector('.lanl-mobile-nav--active');

    if (mobileNav) {
      if (open) {
        mobileNav.style.overflowY = 'hidden';
      } else {
        mobileNav.style.overflowY = 'scroll';
      }
    }
  }, [open]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: MobileNavdrawerClasses,
    "data-testid": "lanl-mobile-nav-drawer"
  }, children);
};

MobileNavDrawer.defaultProps = {
  open: false
};
MobileNavDrawer.propTypes = {
  children: index['default'].node,
  className: index['default'].string,
  open: index['default'].bool
};
exports.MobileNavDrawer = MobileNavDrawer;
exports['default'] = MobileNavDrawer;